import { render, staticRenderFns } from "./RegisterAvatar.vue?vue&type=template&id=1e3b7bd1&scoped=true&"
import script from "./RegisterAvatar.vue?vue&type=script&lang=js&"
export * from "./RegisterAvatar.vue?vue&type=script&lang=js&"
import style0 from "./RegisterAvatar.scss?vue&type=style&index=0&id=1e3b7bd1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3b7bd1",
  null
  
)

export default component.exports